export type ConductorTab = "playbooks" | "plans";

export interface ConductorRoute {
  tab: ConductorTab;
  playbookId?: string;
  planId?: string;
}

const idFromParams = (params: URLSearchParams, name: string): string | undefined => {
  const value = params.get(name)?.trim();
  return value || undefined;
};

// Keep the selected Conductor resource in the URL so a detail page can be
// bookmarked or safely reloaded. A playbook plus a plan preserves the
// playbook-to-plan breadcrumb context.
export const parseConductorRoute = (search: string): ConductorRoute => {
  const params = new URLSearchParams(search);
  const playbookId = idFromParams(params, "playbook_id");
  const planId = idFromParams(params, "plan_id");
  const requestedTab = params.get("tab") === "plans" ? "plans" : "playbooks";

  return {
    // Resource links take precedence over tab so links are never ambiguous.
    tab: playbookId ? "playbooks" : planId ? "plans" : requestedTab,
    ...(playbookId ? { playbookId } : {}),
    ...(planId ? { planId } : {}),
  };
};

// Retain unrelated query parameters (for example, tracking parameters) while
// replacing only the state that belongs to the Conductor UI.
export const createConductorSearch = (search: string, route: ConductorRoute): string => {
  const params = new URLSearchParams(search);
  params.set("tab", route.tab);

  if (route.playbookId) {
    params.set("playbook_id", route.playbookId);
  } else {
    params.delete("playbook_id");
  }

  if (route.planId) {
    params.set("plan_id", route.planId);
  } else {
    params.delete("plan_id");
  }

  return `?${params.toString()}`;
};
